(function (window) {
  "use strict";

  var CHAT_GA4_MESSAGE_TYPE = "_CHAT_GA4";
  var CHATBOT_ORIGIN_SUFFIXES = [
    "chatbot-dev.digimalls.com.br",
    "chatbot.digimalls.com.br",
    "chatbot-hml.digimalls.com.br",
    "widget.chatbotiara.com.br",
  ];

  function isChatbotOrigin(origin) {
    if (!origin || typeof origin !== "string") {
      return false;
    }

    var i;
    for (i = 0; i < CHATBOT_ORIGIN_SUFFIXES.length; i++) {
      if (origin.indexOf(CHATBOT_ORIGIN_SUFFIXES[i]) !== -1) {
        return true;
      }
    }
    return false;
  }

  function safeDataLayerCall(fn) {
    if (typeof fn !== "function") {
      return;
    }
    try {
      fn();
    } catch (e) {
      /* GA helpers must not break page UX */
    }
  }

  function handleChatGa4Event(eventName) {
    switch (eventName) {
      case "launcher_click":
        safeDataLayerCall(window.dataLayerChatbotLauncherClick);
        break;
      case "link_view":
        safeDataLayerCall(window.dataLayerChatbotLinkView);
        break;
      case "link_click":
        safeDataLayerCall(window.dataLayerChatbotAcesseAquiClick);
        break;
      default:
        break;
    }
  }

  window.addEventListener("message", function (event) {
    var data = event.data;

    if (!data || !isChatbotOrigin(event.origin)) {
      return;
    }

    if (data.type === CHAT_GA4_MESSAGE_TYPE && data.event) {
      handleChatGa4Event(data.event);
    }
  });
})(window);
